<template>
  <section>

    <div class="live-score" v-if="mode === 'preview'">

      <div v-if="isTennis" class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
<!--              <div class="ping-serving" v-if="isServing(player.position)"></div>-->
              <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>

      <div v-else-if="isFootball" class="generic-score">
        <div class="home">{{ genericScore.home }}</div>
        <div class="away">{{ genericScore.away }}</div>
      </div>
      <div v-else class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
              <!--              <div class="ping-serving" v-if="isServing(player.position)"></div>-->
              <span class="current-game">
              {{ player.position === '1' ? genericScore.home : genericScore.away}}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>




    </div>

    <div class="live-score detail" v-else>

      <div v-if="isTennis" class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
              <div class="player-name">
                <div class="ping-serving" :class="isServing(player.position) ? 'current' : ''"></div>
                {{player.name}}
              </div>
              <span class="current-game">
              {{ getGameScore(player.position) }}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>



      <div v-else class="tennis-score">
        <div class="score-period">

          <div class="current-period">
            <div class="current-game-row"
                 v-for="(player, idx) in players"
                 :key="idx">
              <div class="player-name">
                {{player.name}}
              </div>
              <span class="current-game">
              {{ player.position === '1' ? genericScore.home : genericScore.away}}
            </span>
            </div>
          </div>

          <div class="container_period">
            <div class="period" v-for="(set, i) in sets" :key="set.type || i">
              <span class="period-header">{{ i + 1 }}</span>
              <span class="period-value" :class="[winnerPeriod(set, '1') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "1") }}
            </span>
              <span class="period-value" :class="[winnerPeriod(set, '2') ? 'win' : '', !set.isFinished ? 'current' : '']">
              {{ getSetScore(set, "2") }}
            </span>
            </div>
          </div>

        </div>
      </div>



    </div>


  </section>
</template>

<script>
  export default {
    name: 'ScoreboardLive',

    props: {
      sportId: {
        type: [String, Number],
        required: true
      },
      livescore: {
        type: Object,
        required: false,
        default: () => ({})
      },
      mode: {
        type: String,
        required: false,
        default: "preview"
      },
      competitors: {
        type: Object,
        required: false,
        default: null
      }
    },

    computed: {
      /* ================= FLAGS ================= */
      isTennis() {
        return String(this.sportId) === "54094";
      },
      isBasket() {
        return String(this.sportId) === "48242";
      },

      isFootball() {
        return String(this.sportId) === "6046";
      },

      /* ================= COMMON ================= */
      players() {
        if(this.competitors)
          return [{ "position": "1", name: this.competitors.home }, { "position": "2" , name: this.competitors.away}];
        else
          return [{ "position": "1" }, { "position": "2" }];
      },

      /* ================= TENNIS / BASKET SETS ================= */
      sets() {
        // FIX: Check assoluto su livescore e periods
        if (!this.livescore || !this.livescore.periods || !Array.isArray(this.livescore.periods)) return [];

        return this.livescore.periods
                .filter(p => p && p.type <= '5')
                .sort((a, b) => Number(a.type) - Number(b.type));
      },

      currentGame() {
        if (!this.livescore || !this.livescore.periods || !Array.isArray(this.livescore.periods)) return null;
        return this.livescore.periods.find(p => p && p.type === '60') || null;
      },

      /* ================= GENERIC (CALCIO) ================= */
      genericScore() {
        // FIX: Nessun optional chaining (?.), usiamo check espliciti per massima compatibilità Babel
        if (!this.livescore || !this.livescore.scoreboard || !this.livescore.scoreboard.results || !Array.isArray(this.livescore.scoreboard.results)) {
          return { home: '-', away: '-' };
        }

        const results = this.livescore.scoreboard.results;
        const homeResult = results.find(r => r && String(r.position) === '1');
        const awayResult = results.find(r => r && String(r.position) === '2');

        return {
          home: homeResult ? homeResult.value : '0',
          away: awayResult ? awayResult.value : '0'
        };
      }
    },

    methods: {
      isServing(position) {
        if (!this.livescore || !this.livescore.livescoreExtraData || !Array.isArray(this.livescore.livescoreExtraData)) return false;

        const serve = this.livescore.livescoreExtraData.find(e => e && e.name === 'Turn');
        if (!serve) return false;

        return String(position) === String(serve.value);
      },

      /* ================= HELPERS ================= */
      getSetScore(set, position) {
        if (!set || !set.results || !Array.isArray(set.results)) return '-';
        const res = set.results.find(r => r && String(r.position) === String(position));
        return res ? res.value : '0';
      },

      winnerPeriod(set, position) {
        if (!set || !set.isFinished || !set.results || !Array.isArray(set.results)) return false;

        const target = set.results.find(r => r && String(r.position) === String(position));
        if (!target) return false;

        const targetValue = Number(target.value);
        return set.results.every(r => r && Number(r.value) <= targetValue);
      },

      getGameScore(position) {
        if (this.isTennis) {
          if (!this.currentGame || !this.currentGame.results || !Array.isArray(this.currentGame.results)) return '0';
          const res = this.currentGame.results.find(r => r && String(r.position) === String(position));
          return res ? res.value : '0';
        }

        if (this.isBasket) {
          if (!this.livescore || !this.livescore.scoreboard || !this.livescore.scoreboard.results || !Array.isArray(this.livescore.scoreboard.results)) return '0';
          const res = this.livescore.scoreboard.results.find(r => r && String(r.position) === String(position));
          return res ? res.value : '0';
        }

        return '';
      }
    }
  }
</script>

<style scoped>
  .live-score {
    font-size: var(--font-size-4xl);
  }

  /* ===== TENNIS ===== */
  .tennis-score { display: flex; align-items: center; }
  .score-period { display: flex; gap: 8px; align-items: flex-end; }

  .current-period {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    padding-right: 8px;
    justify-content: center;
    min-width: 25px;
    overflow: visible;
  }

  .period {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 15px;
  }

  .period-header { font-size: var(--font-size-xs); color: rgba(255, 255, 255, 0.5); margin-bottom: 2px; }
  .period-value { color: #fff; font-weight: 400; font-size: var(--font-size-3xl); line-height: 1.4; }
  .period-value.win { font-weight: 800; color: #fff; }
  .period-value.current { color: var(--color-secondary); font-weight: 700; }

  .current-game-row {
    position: relative;
    display: flex;
    justify-content: flex-end;
    height: 18px;
    align-items: center;
    overflow: visible;
  }

  .current-game {
    font-weight: 800;
    color: var(--color-secondary);
    font-size: var(--font-size-3xl);
  }

  .live-score:not(.detail) .current-period, .live-score:not(.detail) .period {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: .5rem;
    border-right: none;
    padding-right: 0;
  }
  .live-score:not(.detail) .current-game-row {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--text-platform);
    background: hsla(0,0%,100%,.2);
    font-size: var(--font-size-2xl);
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .live-score:not(.detail) .current-game-row .current-game {
    color: var(--text-platform);
  }

  .live-score:not(.detail) .period-value{
    width: 1.5rem;
    height: 1.5rem;
    color: var(--text-platform);
    font-size: var(--font-size-2xl);
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ping-serving {
    height: 5px; width: 5px;
    background: hsla(0, 0%, 100%, .4);
    border-radius: 50%;
    z-index: 10;
  }
  .ping-serving.current {
    background: var(--color-secondary);
    animation: ping 1s infinite;
  }

  @keyframes ping {
    0% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(1.2); }
    100% { opacity: 1; transform: scale(1); }
  }

  /* ===== BASKET ===== */
  .score-basket-wrapper { display: flex; }
  .score-basket { display: flex; gap: 8px; align-items: flex-end; }

  .current-quarter {
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    padding-left: 8px;
    justify-content: center;
  }

  /* ===== GENERIC (CALCIO) ===== */
  .generic-score {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: .5rem;
  }
  .home, .away {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--text-platform);
    background: hsla(0,0%,100%,.2);
    font-size: var(--font-size-2xl);
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .player-name{
    font-size:var(--font-size-3xl);
  }

  .container_period {
    display: flex;
    gap: 8px; align-items: flex-end;
  }

  @media (max-width: 600px) {
    .match-time { margin-bottom: 0; }
    .generic-score{
      line-height: 16px;
      gap: 8px;
    }
    .generic-score, .period-value, .current-game { font-size: var(--font-size-4xl); }
    .score-period, .score-basket {
      max-width: 60px;
      overflow-x: auto;
      overflow-y: visible;
    }
    .live-score.detail .score-period{
      max-width: 100%!important;
    }
  }

  .live-score.detail .generic-score {
    display: flex;
    flex-direction: row;
    font-size: var(--font-size-10xl);
    gap: 2px;
    color: var(--text-platform);
  }
  .live-score.detail .generic-score .home, .live-score.detail .generic-score .away {

    color: var(--text-platform);
  }


  /* ===== TENNIS ===== */
  .live-score.detail .tennis-score {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .live-score.detail .score-period {
    display: flex;
    gap: 16px;
    align-items: last baseline;
    width: 100%;
    justify-content: center;
  }

  .live-score.detail .current-period {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    padding-right: 8px;
    justify-content: center;
    min-width: 200px; /* spazio per nome completo */
    flex-shrink: 0;
  }

  .live-score.detail .current-game-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 24px;
  }

  .live-score.detail .player-name {
    font-size: var(--font-size-3xl);
    white-space: nowrap; /* evita il taglio */
    overflow: visible;
    min-width: 90px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .live-score.detail .current-game {
    font-weight: 800;
    color: var(--color-secondary);
    font-size: var(--font-size-4xl);
    min-width: 20px;
    text-align: right;
  }

  .live-score.detail .container_period {
    display: flex;
    gap: 12px;
    align-items: flex-end;
  }

  .live-score.detail .period {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 22px;
  }
  .live-score.detail .period-value{
    min-height: 24px;
  }

</style>